import React, {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {useConditions, useQuery} from '../../data/hooks/query';
import {useShowPreview} from '../../data/hooks/ui';
import AddCondition from './AddCondition/AddCondition';
import Condition from './Condition/Condition';
import Header from './Header/Header';
import layoutStyles from './LayoutColumns/LayoutColumns.module.scss';
import Preview from './Preview/Preview';
import RequiredUserActions from './RequiredUserActions/RequiredUserActions';

function QueryBuilder(props) {
    const {onChange, onShowPreview} = props,
        query = useQuery(),
        conditions = useConditions(),
        dispatch = useDispatch(),
        showPreview = useShowPreview();

    useEffect(() => {
        if (onChange) onChange(query);
    }, [query]);

    return (
        <>
            {showPreview ? <div className={layoutStyles.filterPreviewBackground}></div> : null}
            <div className="NWAQueryBuilder">
                <Header />
                <RequiredUserActions />
                {conditions.map((condition, i) => {
                    return <Condition key={i} conditionIndex={i} condition={condition} title={i == 1 ? 'Only if' : i > 1 ? 'And' : null} />;
                })}
                <AddCondition />
                <Preview onShowPreview={onShowPreview} />
            </div>
        </>
    );
}

export default QueryBuilder;
